export default {
    name: 'demo-component',
    data(){
        return {
            demotitle: "This is a Vue component"
        }
    },
    computed:{
        demovalue(){
            return this.$store.state.main.demovalue
        }
    }
}